import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Fragment, type PropsWithChildren, useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

// 'en', 'fr', 'de', 'es', 'it', 'pt', 'cs', 'zh'
export type SupportedLocale = 'en' | 'fr' | 'de' | 'es' | 'it' | 'pt' | 'cs' | 'zh';
export type IntlProviderProps = {
  locales: Record<SupportedLocale, Record<string, string>>;
  // optional: default locale used before sgwtAccountCenter provides it. by default, it is "en"
  defaultLocale?: SupportedLocale;
};

export const IntlProvider = (props: PropsWithChildren<IntlProviderProps>) => {
  const { locales, defaultLocale = 'en', children } = props;

  const { sgwtAccountCenter } = useSgwtWidgets();
  const [locale, setLocale] = useState<SupportedLocale>(defaultLocale);

  // Use the SGWT Widgets bus to be aware of the modification of the language,
  // which is triggered by the <sgwt-account-center> widget.
  useEffect(() => {
    const newLocale = sgwtAccountCenter?.lang;

    if (newLocale !== undefined && Object.keys(locales).includes(newLocale)) {
      setLocale(newLocale as SupportedLocale);

      document.documentElement.lang = newLocale;
    }
  }, [sgwtAccountCenter?.lang, locales]);

  return (
    <ReactIntlProvider locale={locale} defaultLocale="en" messages={locales[locale]} textComponent={Fragment}>
      {children}
    </ReactIntlProvider>
  );
};
